const stop = false;

const reducer = (state = stop, action) => {
  switch (action.type) {
    case 'force_stop':
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
